import { makeStyles } from "@material-ui/core";
import { whiteGrey, white } from "../../constants/colors";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  mainForm: {
    backgroundColor: white,
    padding: "30px 60px",
    [down("sm")]: {
      padding: "30px 40px",
    },
    [down("xs")]: {
      padding: "25px 10px",
    },
  },
  secondaryForm: {
    backgroundColor: whiteGrey,
    padding: "20px",
    [down("sm")]: {
      padding: "30px 40px",
      backgroundColor: white,
    },
    [down("xs")]: {
      padding: "19px",
      backgroundColor: white,
      paddingBottom: "100px",
    },
  },
  formHeader: {
    position: "relative",
    [down("xs")]: {
      "& h1": {
        fontSize: "19px",
      },
    },
  },
  headerText: {
    width: "100%",
    [down("xs")]: {
      width: "80%",
    },
  },
  cardForm: {
    background: whiteGrey,
    padding: "40px 110px",
    borderRadius: "20px",
    [down("md")]: {
      padding: "30px 90px",
    },
    [down("sm")]: {
      padding: "20px 80px",
    },
    [down("xs")]: {
      padding: "19px",
    },
  },
}));

export default useStyles;
